export default __webpack_public_path__ + "static/reactfiles/us.3cc0d38b.svg";